import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { applyTheme, readTheme } from "./app/theme";
import { applyShellMode } from "./lib/devices/bridge";

import "./styles/base.css";
import "./styles/glass.css";
import "./components/ui/ui.css";
import "./components/layout/layout.css";

// Mavzu va oyna rejimi React yuklanishidan OLDIN qo'llanadi: aks
// holda qorong'i mavzuda bir lahza oq ekran ko'rinib ketardi.
applyTheme(readTheme());
applyShellMode();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
